// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"03f29c7e","453":"5d79306b","522":"2788544b"}[chunkId] + ".chunk.js";
};